<template>
    <div :class="{'display' : this.$props.visible}" class="full-container">
        <pulse-loader :loading="true"></pulse-loader>
    </div>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

    export default {
        name: "Loader",
        components: {
            PulseLoader
        },
        props: ['visible']

    }
</script>

<style scoped>
    .display{
        display: flex !important;
    }
    .full-container {
        background: rgba(255,255,255,0.95);
        overflow: hidden;
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        display: none;
        justify-content: center;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/loader.vue